import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    links: [
      { label: '每日大赛', href: '/category/meiri-dasai' },
      { label: '明星八卦', href: '/category/mingxing-bagua' },
      { label: '网红爆料', href: '/category/wanghong-baoliao' },
      { label: '热点深度', href: '/category/redian-shendu' },
    ],
  },
  {
    title: '特色栏目',
    links: [
      { label: '黑料百科', href: '/category/heiliaobaike' },
      { label: '独家资源', href: '/category/dujia-ziyuan' },
      { label: '最新爆料', href: '/category/meiri-dasai' },
      { label: '热门排行', href: '/' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系我们', href: '/about' },
      { label: '用户口碑', href: '/about' },
      { label: '常见问题', href: '/about' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { label: '娱乐头条', href: '#', },
      { label: '吃瓜社区', href: '#', },
      { label: '八卦周刊', href: '#', },
      { label: '明星动态', href: '#', },
    ],
  },
];

const socialLinks = [
  { icon: 'ri-weibo-line', href: '#', label: '微博' },
  { icon: 'ri-wechat-line', href: '#', label: '微信' },
  { icon: 'ri-tiktok-line', href: '#', label: '抖音' },
  { icon: 'ri-bilibili-line', href: '#', label: 'B站' },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-16">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-bold text-background-50 mb-4 pb-3 border-b border-foreground-700/40">
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8 pt-12 border-t border-foreground-700/30">
          <div>
            <p className="text-4xl md:text-5xl font-heading font-black text-background-50 leading-none tracking-tight">
              51黑料网
            </p>
            <p className="text-3xl md:text-4xl font-heading font-black text-primary-500 leading-none tracking-tight mt-1">
              吃瓜第一站
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-10 h-0.5 bg-primary-500"></span>
              <p className="text-xs text-foreground-400">24小时黑料不打烊 · 全网资源整合平台</p>
            </div>
          </div>

          <div className="flex flex-col items-start md:items-end gap-4">
            <div className="flex items-center gap-4">
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  rel="nofollow"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-all duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 51黑料网 版权所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}